import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import CompanyActions from '~/actions/company';

const Header = () => (
    <div className="d-flex border-bottom pb-3 desktop-screen">
        <div className="d-flex-5">
            <span className="dsl-m12">Company</span>
        </div>
        <div className="d-flex-4">
            <span className="dsl-m12">Admin</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Products</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Library</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Blogs</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">Connections</span>
        </div>
        <div className="d-flex-2">
            <span className="dsl-m12">HCM</span>
        </div>
        <div className="w30" />
    </div>
);

const Content = ({ search, companies, onChange, onSearch }) => {
    const dispatch = useDispatch();
    const handleEditDropdown = (company) => (e) => {
        const payload = { id: company.id };
        const slug = company?.vrs?.entity?.slug || company?.vrs?.slug;
        const route = slug ? `/${slug}/${e === 'view' ? 'about' : 'account-admin'}` : `/business/${e === 'view' ? 'about' : 'account-admin'}?id=${company.id}`;
        switch (e) {
            case 'edit':
                dispatch(CompanyActions.getbusinessRequest(payload, route));
                break;

            case 'view':
                dispatch(CompanyActions.getbusinessRequest(payload, route));
                break;

            default:
                break;
        }
    };

    return (
        <>
            <div className="d-flex ssm-column mb-4">
                <Input placeholder="Search here..." value={search} onChange={onSearch} />
                <Button className="ml-4 ssm-l-0 ps-3 ssp-l-0 me-auto" name="SEARCH" type="link" />
            </div>
            {companies.data.length !== 0 ? (
                <>
                    <Header />
                    {companies.data.map((company) => {
                        const admins = company.vrs?.admins || [];
                        const adminNames = admins.map((e) => `${e.first_name} ${e.last_name}`);
                        return (
                            <div className="content-item d-h-start d-flex ssm-column border-bottom py-3 ai-center ssm-ai-start" key={company.id}>
                                <div className="d-h-start d-flex-5 w-100 justify-content-between">
                                    <div className="d-flex ai-center">
                                        <Avatar url={company.vrs?.avatar} />
                                        <span className="dsl-b14 text-400 ms-2">{company.name}</span>
                                    </div>
                                    <EditDropdown className="mobile-screen" options={['Add', 'Edit', 'View']} onChange={handleEditDropdown(company)} />
                                </div>
                                <div className="d-flex-4 w-100">
                                    <label className="dsl-b14 mobile-screen w-40">Admin</label>
                                    <span className="dsl-b14 text-400">{adminNames.join(', ')}</span>
                                </div>
                                <div className="d-flex-2 w-100">
                                    <label className="dsl-b14 mobile-screen w-40">Product</label>
                                    <span className="dsl-b14 text-400">{company.has_products ? 'Yes' : 'No'}</span>
                                </div>
                                <div className="d-flex-2 w-100">
                                    <label className="dsl-b14 mobile-screen w-40">Library</label>
                                    <span className="dsl-b14 text-capitalize text-400">{company.has_library}</span>
                                </div>
                                <div className="d-flex-2 w-100">
                                    <label className="dsl-b14 mobile-screen w-40">Blogs</label>
                                    <span className="dsl-b14 text-400">{company.has_blog ? 'Public' : 'No'}</span>
                                </div>
                                <div className="d-flex-2 w-100">
                                    <label className="dsl-b14 mobile-screen w-40">Connections</label>
                                    <span className="dsl-b14 text-400">{company.has_connections ? 'Yes' : 'No'}</span>
                                </div>
                                <div className="d-flex d-flex-2 flex-column">
                                    {company.hcm_features.map((hcm, index) => (
                                        <span className="dsl-b14 text-400 mb-1" key={`${company.id}-${index}`}>
                                            {hcm}
                                        </span>
                                    ))}
                                </div>
                                <div className="w30">
                                    <EditDropdown className="desktop-screen" options={['Edit', 'View']} onChange={handleEditDropdown(company)} />
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                <p className="dsl-b16 no-content">No content</p>
            )}
            <Pagination current={companies.current_page} total={companies.last_page} per={20} pers={[]} onChange={(e) => onChange({ page: e, per_page: 20 })} />
        </>
    );
};

Content.propTypes = {
    search: PropTypes.string,
    companies: PropTypes.shape({
        current_page: PropTypes.number,
        data: PropTypes.array,
        last_page: PropTypes.number,
        per_page: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        from: PropTypes.number,
        to: PropTypes.number,
        total: PropTypes.number,
    }),
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
};

Content.defaultProps = {
    search: '',
    companies: {
        current_page: 0,
        data: [],
        last_page: 0,
        per_page: 10,
        from: 0,
        to: 0,
        total: 0,
    },
    onChange: () => {},
    onSearch: () => {},
};

export default Content;
